/*
 * File: PageSubHeader.tsx
 * Project: meryl-sheep
 * -----
 * Last Modified: 12 Oct 2020 11:55:01 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { Col, Menu, MenuProps, Row } from 'antd';
import { CompanySelect } from 'components/atoms/CompanySelect';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const styles: InlineStylesModel = {
  row: {
    backgroundColor: '#181823',
    padding: '0 50px',
    color: '#84859a',
    fontSize: '1rem',
    maxWidth: 1920,
    margin: '0 auto'
  },
  menuContainer: {
    height: '100%',
    width: '100%'
  }
};

export const PageSubHeader = (): JSX.Element => {
  const { pathname } = useLocation();

  const [selectedMenu, _setSelectedMenu] = useState<string>('search');

  const isDraft = pathname.includes('/drafts');
  const isPosted = pathname.includes('/posted');

  const showDetails = isDraft || isPosted;

  const featureMenuItems: MenuProps['items'] = [
    {
      key: 'search',
      label: <Link to="/">Search</Link>
    },
    {
      key: 'create',
      label: <Link to="/create">Create</Link>
    }
  ];

  if (showDetails) {
    featureMenuItems.push({
      key: 'details',
      label: 'Order Details'
    });
  }

  const featureMenuJSX = (
    <Menu
      disabledOverflow={true}
      mode="horizontal"
      theme="dark"
      style={showDetails ? styles.largeContainer : styles.smallContainer}
      activeKey={selectedMenu}
      defaultSelectedKeys={[selectedMenu]}
      selectedKeys={[selectedMenu]}
      items={featureMenuItems}></Menu>
  );

  useEffect(() => {
    if (pathname.includes('/create')) _setSelectedMenu('create');
    if (pathname.includes('/drafts/') || pathname.includes('/orders/') || pathname.includes('/posted')) _setSelectedMenu('details');
    if (!pathname.includes('/drafts/') && !pathname.includes('/orders/') && !pathname.includes('/create') && !pathname.includes('/posted')) _setSelectedMenu('search');
  }, [pathname]);

  return (
    <div style={{ width: '100%', backgroundColor: 'rgb(24, 24, 35)' }}>
      <Row style={styles.row} justify="space-between" align="middle">
        <Col>
          <CompanySelect />
        </Col>
        <Col>{featureMenuJSX}</Col>
      </Row>
    </div>
  );
};
